import React from 'react';
import css from './styles.module.scss';
import { Grid, TextField, Typography } from '@material-ui/core';


interface InputProps {
    id: string;
    name: string;
    label: string;
    value: string;
    isPadding: boolean;
    elementFocus: any;
    updateData: any;
    isDisabled: boolean;
    inputRef: any;
    inputLabelProps: any;
    error: any;
    helperText: any;
}

export const DealInput: React.FC<InputProps> = ({ id, name, label, value, isPadding, elementFocus, updateData, isDisabled, inputRef, inputLabelProps, error, helperText }) => {
    return (
        <>
            <Grid container spacing={0} alignItems="flex-end" className={isPadding ? css.dividerInput : ''} onClick={() => elementFocus(inputRef)}>
                <Grid item xs={12} className={css.grid2}>
                    <Typography className={css.textInput}>{label}</Typography>
                    <TextField
                        id={id}
                        inputRef={inputRef}
                        name={name}
                        onChange={e => updateData(name, e.target.value)}
                        // value={value ? value : ''}
                        variant="outlined"
                        // disabled={isDisabled}
                        // required
                        fullWidth
                        className={isDisabled ? css.textFieldDisable : css.textField}
                        InputLabelProps={inputLabelProps}
                        error={error}
                        helperText={helperText}
                    />
                </Grid>
            </Grid>
        </>
    );
};
